import React from 'react'
import { Table } from 'semantic-ui-react'

import { TableHeaderCell } from '../../../../../components/Table'
import { Pagination } from '../../../../../contexts/PaginationContext'

interface ProductsTableHeaderProps {
  pagination: Pagination
  changeOrderBy: (field: string) => void
}

export const ProductsTableHeader: React.FC<ProductsTableHeaderProps> = ({
  pagination,
  changeOrderBy
}) => {
  return (
    <Table.Header>
      <Table.Row>
        <TableHeaderCell
          content="Descrição"
          name="description"
          pagination={pagination}
          onClick={() => changeOrderBy('description')}
        />
        <Table.HeaderCell />
      </Table.Row>
    </Table.Header>
  )
}
